import { render, staticRenderFns } from "./form.vue?vue&type=template&id=f4f9926a&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f9926a')) {
      api.createRecord('f4f9926a', component.options)
    } else {
      api.reload('f4f9926a', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=f4f9926a&", function () {
      api.rerender('f4f9926a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/lga/form.vue"
export default component.exports